var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / notifications / new"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3187 24.6807C12.7924 24.6807 13.9877 23.4853 13.9877 22.0104H8.64966C8.64966 23.4853 9.84503 24.6807 11.3187 24.6807ZM20.3055 18.4343C19.4994 17.5681 17.9911 16.2651 17.9911 11.9968C17.9911 8.7549 15.718 6.15971 12.653 5.52302V4.6535C12.653 3.91625 12.0555 3.31836 11.3187 3.31836C10.5819 3.31836 9.98438 3.91625 9.98438 4.6535V5.52302C6.91939 6.15971 4.64631 8.7549 4.64631 11.9968C4.64631 16.2651 3.13802 17.5681 2.33192 18.4343C2.08158 18.7034 1.9706 19.0251 1.97269 19.3401C1.97727 20.0243 2.51425 20.6752 3.312 20.6752H19.3254C20.1231 20.6752 20.6605 20.0243 20.6647 19.3401C20.6668 19.0251 20.5558 18.703 20.3055 18.4343Z",
    fill: "#F7F8FC"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "new",
    cx: 17.9947,
    cy: 5.98785,
    r: 4.50543,
    fill: "#EB5757",
    stroke: "#1C1D22"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.5c53ad2db3f286900ffb63b873a162cb.svg";
export { ForwardRef as ReactComponent };